let slideOptions = {
    "duration": 200,
    "delay": 0,
    "direction": "bottom"
};

export function footer_viewportEnter(event) {
    $w("#UParrow").show("slide", slideOptions)
}

export function footer_viewportLeave(event) {
    $w("#UParrow").hide("slide", slideOptions)
}